import styled from 'styled-components'
import { SIZES } from '../../constants'

export default styled.span`
  background: url(${STATICS_PATH}images/video/play-photo-sprite.png);
  display: block;
  height: 32px;
  left: 13px;
  position: absolute;
  bottom: 13px;
  width: 32px;

  &.videoIcon {
    background-position: 0 -106px;
  }

  &.galleryIcon {
    height: 24px;
    background-position: 0 -392px;
  }
  
  @media (max-width: ${SIZES.BREAKPOINT_SM - 1}px) {
    &.videoIcon {
      height: 24px;
      background-position: 0 -172px;
    }
  }
`
